module.exports = function() {
	return new Worker(__webpack_public_path__ + "worker.js");
};


//////////////////
// WEBPACK FOOTER
// d:/documents/git/krkrsvchk/krkrsvchk_web/~/worker-loader?name=worker.js!d:/documents/git/krkrsvchk/krkrsvchk_web/worker.js
// module id = 549
// module chunks = 1